import styled from "@emotion/styled";
import { colors } from "../../../styles/colors";
import { fonts } from "../../../styles/fonts";

export const JoinWrap = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${colors.MAIN_RED};
  width: 832px;
  height: 228px;
  margin: 0 auto;
  button {
    max-width: 208px;
    width: 100%;
    margin: 0 auto;
  }
  border-radius: 20px;
  @media (max-width: 769px) {
    flex-direction: column;
    margin-bottom: 0;
    margin-top: 62px;
    width: 328px;
    height: 228px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  line-height: 42px;
`;
